import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-registered-thanks',
  templateUrl: './registered-thanks.component.html',
  styleUrls: ['./registered-thanks.component.css']
})
export class RegisteredThanksComponent implements OnInit {

  constructor(
    private cookie:CookieService,
  ) { }

  ngOnInit() {
    this.cookie.deleteAll();
    localStorage.clear();
    
  }

}
